import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from "@angular/core";

@Component({
  selector: "school-levels-select",
  templateUrl: "./school-levels-select.component.html",
  styleUrls: ["./school-levels-select.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SchoolLevelsSelectComponent implements OnInit {
  @Input() schoolLevels;
  @Input() selectedSchoolLevel;
  @Output() schoolLevelSelected = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
